export default __webpack_public_path__ + "static/media/Asset-70.c98ff640.png";